function Err404Page(){
    return (
        <div style={{textAlign: "center"}}>
            <h1>404 Not Found.</h1>
        </div>
    )
}

export default Err404Page